import { useState, useEffect } from "react";
import { components } from "react-select";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../common/http-common";
import * as common from "../../common/common";
import * as Comp from "../../common/CommonComponents";
import { GetPagePermissionFn } from "../../common/authority";
import CssClass from "../../Styles/common.module.css";
import SystemInfoListTable from "../../components/SystemInfo/SystemInfoListTable";
import SystemInfoRegister from "../../components/SystemInfo/SystemInfoRegister";
import register from "../../assets/register-icon.png";
import search from "../../assets/search-icon.png";
// import exportIcon from "../../assets/export-icon.png";

const PAGE_NAME = "SystemInfo.js";
const MODULE_ID = "WEB_SYSIN_001";

const SystemInfo = (props) => {
  document.title = common.c_TITLE + " - SystemInfo";

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [ConnData, setConnData] = useState([]);
  const [Conn, setConn] = useState(null);
  const [companyData, setCompanyData] = useState([]);
  const [company, setCompany] = useState([]);
  const [systemData, setSystemData] = useState([]);
  const [system, setSystem] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedSystem, setSelectedSystem] = useState([]);

  const [searchData, setSearchData] = useState([]);
  const [allData, setAllData] = useState([]);

  const [dataToBeSelect, setDataToBeSelect] = useState({
      Conn: [],
      System: [],
  });

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);

  const [showAdd, setShowAdd] = useState(false);

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All System";

        onLoadingHandler(true, "Getting System List, please wait...");

        setAllData([]);
        const listItems = [];

        const companySelected = company?.key ? [company.key] : [];
        const systemSelected = system?.key ? [system.key] : [];
        const ConnSelected = Conn ? Conn.value : "";

        http
          .get(
            "api/SystemInfo/GetAllSystemInfo?_userId=" +
              userId + 
              "&_Comp=" +
              companySelected +
              "&_System=" +
              systemSelected +
              "&_Conn=" +
              ConnSelected,
            { timeout: 10000000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                listItems.push({
                  key: data.ORG_SYSTEM_DETAILS_ID,
                  SYSTEM_MST_ID: data.SYSTEM_MST_ID,
                  SYSTEM_MST_NAME: data.SYSTEM_MST_NAME,
                  SERVER_ENV_NAME: data.SERVER_ENV_NAME,
                  SERVER_ENV_ID: data.SERVER_ENV_ID,
                  SERVER_CONN_TYPE_ID: data.SERVER_CONN_TYPE_ID,
                  SERVER_CONN_TYPE_NAME: data.SERVER_CONN_TYPE_NAME,
                  ORG_SYSTEM_DETAILS_ID: data.ORG_SYSTEM_DETAILS_ID,
                  ORG_SYSTEM_ID: data.ORG_SYSTEM_ID,
                  ORG_ID: data.ORG_ID,
                  ORG_NAME: data.ORG_NAME,
                  IP_ADDRESS: data.IP_ADDRESS,
                  URL: data.URL,
                  ID: data.ID,
                  PASSWORD: data.PASSWORD,
                  DB_SID: data.DB_SID,
                  REMARK: data.REMARK,
                  ACTIVE_FLAG: data.ACTIVE_FLAG,
                  STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                  UPDATE_DATETIME: data.UPDATE_DATETIME,
                  UPDATE_ID: data.UPDATE_ID,
                  UPDATE_NAME: data.UPDATE_NAME,
                });
              });
            }
            setAllData(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting system list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting system list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  //#region Event Handlers
  const showHideRegisterModal = () => {
    setShowAdd(!showAdd);
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  useEffect(() => {
      if (actionAuthority.READ === "Y") {
        let functionName = "";

        try {
          functionName = "Get Connection Environment List";
          onLoadingHandler(true, "Getting Connection Environment List, please wait...");
          http
            .get("api/SystemInfo/GetEnvList?_user=" + userId)
            .then((response) => {
              const listItems = [];
              for (var i = 0; i < response.data.length; i++) {
                listItems.push({
                  key: response.data[i].SERVER_ENV_ID,
                  value: response.data[i].SERVER_ENV_ID,
                  label: response.data[i].SERVER_ENV_NAME,
                });
              }
              setConnData(listItems);
              setDataToBeSelect((prevState) => ({
                ...prevState,
                Conn: [...listItems],
              }));
            })
            .catch((err) => {
              toast.error("Error on Connection Environment List. Please try again.");
              common.c_LogWebError(props.page, functionName, err);
            });
        } catch (err) {
          toast.error("Error on getting Connection Environment list. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        }
      } 
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
      if (actionAuthority.READ === "Y") {
        let functionName = "";
  
        setCompanyData([]);
        const listItems = [];
  
        try {
          functionName = "useEffect Get Company List";
          onLoadingHandler(true, "Getting Company List, please wait...");
  
          http
            .get("api/SystemInfo/GetCompanyList?_user=" + userId, { timeout: 10000 })
            .then((response) => {
              if (response.data.length > 0) {
                  response.data.forEach((data, counter) => {
                      listItems.push({
                          key: data.ORG_ID,
                          value: data.ORG_ID,
                          label: data.ORG_NAME,
                      });
                  });
                  setCompanyData(listItems); 
              }
            })
            .catch((err) => {
              toast.error("Error on getting company list. Please try again.");
              common.c_LogWebError(PAGE_NAME, functionName, err);
            })
            .finally(() => {
              onLoadingHandler(false, "Loading...");
            });
        } catch (err) {
          toast.error("Error on getting company list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        }
      }
  }, [actionAuthority, userId]);

  useEffect(() => {
      if (actionAuthority.READ === "Y") {
        let functionName = "";
        
        setSystemData([]);
        const listItems = [];
        //const companySelected = selectedCompany.map(company => company.value);
        const companySelected = selectedCompany?.value ? [selectedCompany.value] : [];

  
        try {
          functionName = "useEffect Get System List";
          onLoadingHandler(true, "Getting System List, please wait...");
  
          http
            .get("api/SystemInfo/GetSystemList?_user=" + userId + "&_orgId=" + companySelected, { timeout: 10000 })
            .then((response) => {
              if (response.data.length > 0) {
                response.data.forEach((data, counter) => {
                    listItems.push({
                        key: data.SYSTEM_MST_ID,
                        value: data.SYSTEM_MST_ID,
                        label: data.SYSTEM_MST_NAME,
                    });
                });
              setSystemData(listItems);
              console.log(listItems);
            }
            })
            .catch((err) => {
              toast.error("Error on getting system list. Please try again.");
              common.c_LogWebError(PAGE_NAME, functionName, err);
            })
            .finally(() => {
              onLoadingHandler(false, "Loading...");
            });
        } catch (err) {
          toast.error("Error on getting system list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        }
      }
  }, [reload, actionAuthority, selectedCompany, userId]);


  const selectCompanyHandler = (val) => {
    let functionName = "";
    try {
        functionName = selectCompanyHandler.name;
  
        setCompany(val)
        setSelectedCompany(val)
        //Clear dependent system selection
        setSystem([]);
        setSelectedSystem([]);
  
    } catch (err) {
        common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }

      // useEffect(() => {
      //   if (actionAuthority.READ === "Y") {
      //     let functionName = "";
    
      //     try {
      //       functionName = "Get System List";
      //       onLoadingHandler(true, "Getting System List, please wait...");
      //       http
      //         .get("api/SystemInfo/GetSystemList?_user=" + userId)
      //         .then((response) => {
      //           const listItems = [];
      //           for (var i = 0; i < response.data.length; i++) {
      //             listItems.push({
      //               key: response.data[i].SYSTEM_MST_ID,
      //               value: response.data[i].SYSTEM_MST_ID,
      //               label: response.data[i].SYSTEM_MST_NAME,
      //             });
      //           }
      //           setSystemData(listItems);
      //           setDataToBeSelect((prevState) => ({
      //             ...prevState,
      //             System: [...listItems],
      //           }));
      //         })
      //         .catch((err) => {
      //           toast.error("Error on System List. Please try again.");
      //           common.c_LogWebError(props.page, functionName, err);
      //         });
      //     } catch (err) {
      //       toast.error("Error on getting System list. Please try again.");
      //       common.c_LogWebError(props.page, functionName, err);
      //     }
      //   } 
      // }, [reload, actionAuthority, userId]);


  /* const onExcelHandler = () => {  
      window.open(common.c_getApiUrl() + "api/SystemInfo/ExportExcel?_user=" + userId);
  } */
  //#endregion

  return (
    <>
      <Comp.Header>System Info</Comp.Header>
      <Comp.SearchPanel onSubmit={onReloadHandler}>
              <tr>
                <td style={{ verticalAlign: "middle", width: "5%" }}>Company</td>
                <td style={{ verticalAlign: "middle", width: "2%" }}>:</td>
                <td style={{ verticalAlign: "middle", width: "20%" }}>
                  <Comp.Select
                    options={companyData}
                    closeMenuOnSelect={true}
                    isClearable={true}
                    hideSelectedOptions={false}
                    // components={{ ValueContainer }}
                    value={selectedCompany}
                    onChange={selectCompanyHandler}
                  />
                </td>
                <td style={{ verticalAlign: "middle", width: "5%" }}>System</td>
                <td style={{ verticalAlign: "middle", width: "2%" }}>:</td>
                <td style={{ verticalAlign: "middle", width: "20%" }}>
                  <Comp.Select
                    options={systemData}
                    closeMenuOnSelect={true}
                    isClearable={true}
                    hideSelectedOptions={false}
                    // components={{ ValueContainer }}
                    value={system}
                    onChange={setSystem}
                  />
                </td>
              <td style={{ verticalAlign: "middle", width: "5%" }}>Prod. / Dev.</td>
                <td style={{ verticalAlign: "middle", width: "2%" }}>:</td>
                <td style={{ verticalAlign: "middle", width: "20%" }}>
                  <Comp.Select
                    options={ConnData}
                    closeMenuOnSelect={true}
                    isClearable={true}
                    hideSelectedOptions={false}
                    // components={{ ValueContainer }}
                    value={Conn}
                    onChange={setConn}
                  />
                </td>
              </tr>
            </Comp.SearchPanel>
      
      <div className={CssClass.btnWrapper}>
              <Comp.Button id="btnSearch" type="general" onClick={onReloadHandler}>
                SEARCH  <img src={search} alt="Search" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
              </Comp.Button>

        {actionAuthority.WRITE === "Y" && (
          <Comp.Button
            id="btnRegister"
            type="general"
            onClick={showHideRegisterModal}
          >
            REGISTER  <img src={register} alt="Register" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
          </Comp.Button>
        )} 
        {/* <Comp.Button id="btnExcel" type="excel" onClick={onExcelHandler}>
          EXPORT  <img src={exportIcon} alt="Export" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button> */}
      </div>
      <div className={`${CssClass.card} ${CssClass.tableCard}`}>
        {/* <h3 className={CssClass.tableTitle}>System list</h3> */}
        {/* <hr /> */}
        <div>
          <SystemInfoListTable
            data={allData}
            onReload={onReloadHandler}
          page={PAGE_NAME}
            module={MODULE_ID}
            onLoading={onLoadingHandler}
            actionAuthority={actionAuthority}
            dataToBeSelect={dataToBeSelect}
          />
        </div>
      </div>
      {<SystemInfoRegister
        showHide={showAdd}
        dataToBeSelect={dataToBeSelect}
        onHide={showHideRegisterModal}
        onReload={onReloadHandler}
        page={PAGE_NAME}
        module={MODULE_ID}
        onLoading={onLoadingHandler}
      />}
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default SystemInfo;
